import axios from 'axios';
import Config from "../config";

export const api = axios.create({
    baseURL: Config.API,
    withCredentials: true,
    headers: {
        'Content-type': 'application/json',
    }
})

export default api;
